import React, { Component } from 'react';
import {Collapse} from 'react-collapse';
import './styles.css';

class FAQItem extends Component {
  constructor(props){
    super(props);
    this.state = {
      isOpened: false,
    }
  }

  displayAnswer(){
    if(this.props.answer.constructor === Array){
      return (
        <ul>
          {this.props.answer.map((ans, key) => {
            return (<li key={key}>{ans}</li>)
          })}
        </ul>
      );
    }
    if(this.props.bullets){
      return (
        <div>
          <span>{this.props.answer}</span>
          <ul>
            {this.props.bullets.map((bul, key) => {
              return (<li key={key}><a href={bul.link} target="_blank">{bul.name}</a></li>)
            })}
          </ul>
        </div>
      );
    }
    if(this.props.withLink){
      let textArr = this.props.answer.split(this.props.withLink.where);
      return (
        <div>
          <span>
            {textArr[0]}
            <a href={this.props.withLink.to} target="_blank">{this.props.withLink.where}</a>
            {textArr[1]}
          </span>
        </div>
      )
    }
    return (<span>{this.props.answer}</span>);
  }

  render(){
    return (
      <div className="faq-list-item">
        <div onClick={() => {
          this.setState({isOpened: !this.state.isOpened})
        }} className={`faq-title ${this.state.isOpened ? 'faq-item-open' : ''}`}>
          {this.props.question}
        </div>
        <Collapse isOpened={this.state.isOpened}>
          <div className="faq-text">
            {this.displayAnswer()}
          </div>
        </Collapse>
      </div>
    );
  }
}

export default FAQItem;



// WEBPACK FOOTER //
// ./src/components/FAQItem/FAQItem.js